module.exports = __webpack_public_path__ + "img/normal_multiplier.9c066a26.png";